var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Field from "./Field.js";
class PasswordField extends Field {
  construct(config = {}) {
    config.inputType = "password";
    super.construct(...arguments);
    this.element.classList.add("b-textfield");
  }
}
__publicField(PasswordField, "$name", "PasswordField");
__publicField(PasswordField, "type", "passwordfield");
__publicField(PasswordField, "alias", "password");
PasswordField.initClass();
PasswordField._$name = "PasswordField";
export {
  PasswordField as default
};
